// 路由示例
import type { RouteRecordRaw } from "vue-router";
import { RouterName } from "@/enums/RouterEnum";

const templateRoutes: RouteRecordRaw[] = [
  {
    path: "/csv",
    redirect: "/quality-report",
  },
  {
    path: "/video",
    redirect: "/quality-report",
  },
  {
    path: "/txt",
    redirect: "/quality-report",
  },
  {
    path: "/quality-report",
    name: RouterName.QUALITY_REPORT,
    component: () => import("@/views/template/Report.vue"),
    meta: {
      title: "典枢",
      hideFloatingService: true,
    },
  },
  {
    path: "/user-protocol",
    name: RouterName.USER_PROTOCOL,
    component: () => import("@/views/protocol/TermsService.vue"),
    meta: {
      title: "典枢",
      hideFloatingService: true,
    },
  },
  {
    path: "/privacy-policy",
    name: RouterName.PRIVACY_POLICY,
    component: () => import("@/views/protocol/PrivacyPolicy.vue"),
    meta: {
      title: "典枢",
      hideFloatingService: true,
    },
  },
  {
    path: "/merchant-protocol",
    name: RouterName.MERCHANT_PROTOCOL,
    component: () => import("@/views/protocol/MerchantProtocol.vue"),
    meta: {
      title: "典枢",
      hideFloatingService: true,
    },
  },
  {
    path: "/quality-report",
    name: RouterName.QUALITY_REPORT,
    component: () => import("@/views/template/Report.vue"),
    meta: {
      title: "典枢",
      hideFloatingService: true,
    },
  },
];

export default templateRoutes;
